import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";
import Vue from 'vue';
import auth from './modules/auth';
import rwd from './modules/rwd';

// Load Vuex
Vue.use(Vuex);
// Create store
export default new Vuex.Store({
  modules: {
    auth,
    rwd
  },
  plugins: [createPersistedState()]
});